"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftCancellationReason = void 0;
exports.instanceOfShiftCancellationReason = instanceOfShiftCancellationReason;
exports.ShiftCancellationReasonFromJSON = ShiftCancellationReasonFromJSON;
exports.ShiftCancellationReasonFromJSONTyped = ShiftCancellationReasonFromJSONTyped;
exports.ShiftCancellationReasonToJSON = ShiftCancellationReasonToJSON;
exports.ShiftCancellationReasonToJSONTyped = ShiftCancellationReasonToJSONTyped;
/**
 *
 * @export
 */
exports.ShiftCancellationReason = {
    DirectRequestDeclined: 'DIRECT_REQUEST_DECLINED',
    FilledInternally: 'FILLED_INTERNALLY',
    LowDepartmentCensus: 'LOW_DEPARTMENT_CENSUS',
    SchedulingError: 'SCHEDULING_ERROR',
    Other: 'OTHER'
};
function instanceOfShiftCancellationReason(value) {
    for (const key in exports.ShiftCancellationReason) {
        if (Object.prototype.hasOwnProperty.call(exports.ShiftCancellationReason, key)) {
            if (exports.ShiftCancellationReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ShiftCancellationReasonFromJSON(json) {
    return ShiftCancellationReasonFromJSONTyped(json, false);
}
function ShiftCancellationReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShiftCancellationReasonToJSON(value) {
    return value;
}
function ShiftCancellationReasonToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ShiftCancellationReason.js.map